import { useEffect, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { VerticalBarChartData } from 'reducers/home';
import { OverallChip } from 'pages/home/components/OverallChip/OverallChip';
import { useTranslation } from 'hooks';

interface Props {
  data: VerticalBarChartData;
}

export const VerticalBarChartView: React.FC<Props> = ({ data }) => {
  const getTranslate = useTranslation();
  const [lineWidths, setLineWidth] = useState<string[]>([]);
  const { chartDate } = data;

  useEffect(() => {
    const values = chartDate.map(({ value }) => value);

    if (values.length > 0) {
      const maxValue = Math.max(...values);
      const widths = values.map(
        (value) => `${Number((value / maxValue) * 100).toFixed(2)}%`
      );

      // delay to trigger CSS transition
      const timeout = setTimeout(() => {
        setLineWidth(widths);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [chartDate]);

  if (!chartDate.length) {
    return (
      <div className='h-full flex flex-col justify-center items-center'>
        <h4 className='font-heading text-heading-l mb-2'>
          {getTranslate('common.noData')}
        </h4>
        <p className='text-m-regular text-text-secondary'>
          {getTranslate('getStarted.graph.noData.text')}
        </p>
      </div>
    );
  }

  return (
    <div>
      {chartDate.map(({ country_code, country_name, increase, value }, idx) => (
        <div
          key={country_code}
          className='relative h-[48px] flex justify-between items-center shadow-[inset_0px_-0.5px_0px_rgba(0,0,0,0.08)]'>
          <div className='flex items-center gap-2'>
            <ReactCountryFlag
              countryCode={country_code}
              alt={`${country_name} flag`}
              svg
              style={{
                width: 20,
                height: 20,
                borderRadius: '100%',
                objectFit: 'cover',
              }}
            />
            <span className='text-m-regular'>{country_name}</span>
          </div>
          <span className='absolute top-1/2 -translate-y-1/2 right-[90px]'>
            {value}
          </span>
          {increase ? <OverallChip value={increase} /> : null}
          <div
            className='absolute bottom-0 left-0 h-[2px] w-0 bg-brand-main rounded-[45px] transition-all duration-1000 ease-in'
            style={{
              width: lineWidths[idx],
            }}></div>
        </div>
      ))}
    </div>
  );
};
